
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type fitmentTableRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableRT(): TemplateResult<fitmentTableRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function repeatField2(field, fieldIndex) {
        return _createElement('th', {
            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
            'key': field,
            'scope': 'col'
        }, _createElement('div', mergeProps({ 'className': 'fitment-cell__value' }, { dangerouslySetInnerHTML: { __html: typeof field === 'undefined' ? '' : field } })));
    }
    function repeatAlwaysVisibleValues3(alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '5481'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function onClick3(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, e) {
                    {
                        const contentElement = e.target.closest('.fitment-cell').querySelector('.fitment-cell__content');
                        const isCollapsed = contentElement.classList.toggle('fitment-cell__content--collapsed');
                        e.target.textContent = isCollapsed ? 'Show more' : 'Show less';
                    }
                }
                function scopeSplittedValuesHasShowMore4(fitment, fitmentIndex, field, value) {
                    var splittedValues = Array.isArray(value) ? value : value.split('\n');
                    var hasShowMore = field === 'Notes' && splittedValues.length > 1;
                    return [
                        _createElement.apply(this, [
                            'div',
                            {
                                'className': 'fitment-cell__content ' + (hasShowMore ? 'fitment-cell__content--collapsed' : ''),
                                'key': '2121'
                            },
                            _map(splittedValues, repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore))
                        ]),
                        hasShowMore ? _createElement('button', {
                            'className': 'fitment-cell__show-more',
                            'type': 'button',
                            'onClick': onClick3.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore),
                            'key': '2123'
                        }, '\n        Show more\n      ') : null
                    ];
                }
                function scopeFieldValue5(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement('td', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': field
                    }, value ? scopeSplittedValuesHasShowMore4.apply(this, [
                        fitment,
                        fitmentIndex,
                        field,
                        value
                    ]) : null);
                }
                function repeatFitment6(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue5.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'tr',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment6.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues4(initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '5481'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function onClick3(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, e) {
                    {
                        const contentElement = e.target.closest('.fitment-cell').querySelector('.fitment-cell__content');
                        const isCollapsed = contentElement.classList.toggle('fitment-cell__content--collapsed');
                        e.target.textContent = isCollapsed ? 'Show more' : 'Show less';
                    }
                }
                function scopeSplittedValuesHasShowMore4(fitment, fitmentIndex, field, value) {
                    var splittedValues = Array.isArray(value) ? value : value.split('\n');
                    var hasShowMore = field === 'Notes' && splittedValues.length > 1;
                    return [
                        _createElement.apply(this, [
                            'div',
                            {
                                'className': 'fitment-cell__content ' + (hasShowMore ? 'fitment-cell__content--collapsed' : ''),
                                'key': '2121'
                            },
                            _map(splittedValues, repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore))
                        ]),
                        hasShowMore ? _createElement('button', {
                            'className': 'fitment-cell__show-more',
                            'type': 'button',
                            'onClick': onClick3.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore),
                            'key': '2123'
                        }, '\n        Show more\n      ') : null
                    ];
                }
                function scopeFieldValue5(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement('td', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': field
                    }, value ? scopeSplittedValuesHasShowMore4.apply(this, [
                        fitment,
                        fitmentIndex,
                        field,
                        value
                    ]) : null);
                }
                function repeatFitment6(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue5.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'tr',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment6.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatField5(field, fieldIndex) {
        return _createElement('th', {
            'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
            'key': field,
            'scope': 'col'
        }, _createElement('div', mergeProps({ 'className': 'fitment-cell__value' }, { dangerouslySetInnerHTML: { __html: typeof field === 'undefined' ? '' : field } })));
    }
    function repeatAlwaysVisibleValues6(alwaysVisibleValues, alwaysVisibleValuesIndex) {
        return [alwaysVisibleValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '5481'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function onClick3(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, e) {
                    {
                        const contentElement = e.target.closest('.fitment-cell').querySelector('.fitment-cell__content');
                        const isCollapsed = contentElement.classList.toggle('fitment-cell__content--collapsed');
                        e.target.textContent = isCollapsed ? 'Show more' : 'Show less';
                    }
                }
                function scopeSplittedValuesHasShowMore4(fitment, fitmentIndex, field, value) {
                    var splittedValues = Array.isArray(value) ? value : value.split('\n');
                    var hasShowMore = field === 'Notes' && splittedValues.length > 1;
                    return [
                        _createElement.apply(this, [
                            'div',
                            {
                                'className': 'fitment-cell__content ' + (hasShowMore ? 'fitment-cell__content--collapsed' : ''),
                                'key': '2121'
                            },
                            _map(splittedValues, repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore))
                        ]),
                        hasShowMore ? _createElement('button', {
                            'className': 'fitment-cell__show-more',
                            'type': 'button',
                            'onClick': onClick3.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore),
                            'key': '2123'
                        }, '\n        Show more\n      ') : null
                    ];
                }
                function scopeFieldValue5(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement('td', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': field
                    }, value ? scopeSplittedValuesHasShowMore4.apply(this, [
                        fitment,
                        fitmentIndex,
                        field,
                        value
                    ]) : null);
                }
                function repeatFitment6(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue5.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'tr',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment6.bind(this))
                ]);
            }, { count: undefined })];
    }
    function repeatInitiallyHiddenValues7(initiallyHiddenValues, initiallyHiddenValuesIndex) {
        return [initiallyHiddenValues(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatSplittedValue2(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, splittedValue, splittedValueIndex) {
                    return [_createElement('div', mergeProps({
                            'className': 'fitment-cell__value',
                            'key': '5481'
                        }, { dangerouslySetInnerHTML: { __html: typeof splittedValue === 'undefined' ? '' : splittedValue } }))];
                }
                function onClick3(fitment, fitmentIndex, field, value, splittedValues, hasShowMore, e) {
                    {
                        const contentElement = e.target.closest('.fitment-cell').querySelector('.fitment-cell__content');
                        const isCollapsed = contentElement.classList.toggle('fitment-cell__content--collapsed');
                        e.target.textContent = isCollapsed ? 'Show more' : 'Show less';
                    }
                }
                function scopeSplittedValuesHasShowMore4(fitment, fitmentIndex, field, value) {
                    var splittedValues = Array.isArray(value) ? value : value.split('\n');
                    var hasShowMore = field === 'Notes' && splittedValues.length > 1;
                    return [
                        _createElement.apply(this, [
                            'div',
                            {
                                'className': 'fitment-cell__content ' + (hasShowMore ? 'fitment-cell__content--collapsed' : ''),
                                'key': '2121'
                            },
                            _map(splittedValues, repeatSplittedValue2.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore))
                        ]),
                        hasShowMore ? _createElement('button', {
                            'className': 'fitment-cell__show-more',
                            'type': 'button',
                            'onClick': onClick3.bind(this, fitment, fitmentIndex, field, value, splittedValues, hasShowMore),
                            'key': '2123'
                        }, '\n        Show more\n      ') : null
                    ];
                }
                function scopeFieldValue5(fitment, fitmentIndex) {
                    var field = fitment[0];
                    var value = fitment[1];
                    return _createElement('td', {
                        'className': 'fitment-cell fitment-field-' + field.toLowerCase(),
                        'key': field
                    }, value ? scopeSplittedValuesHasShowMore4.apply(this, [
                        fitment,
                        fitmentIndex,
                        field,
                        value
                    ]) : null);
                }
                function repeatFitment6(fitment, fitmentIndex, field, value) {
                    return scopeFieldValue5.apply(this, [
                        fitment,
                        fitmentIndex
                    ]);
                }
                return _createElement.apply(this, [
                    'tr',
                    { 'className': 'fitment-row' },
                    _map(Object.entries(this.fitment), repeatFitment6.bind(this))
                ]);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_custom_fitment-table fitment-table-container' }, this.vehicleSpecific ? _createElement('div', {
        'className': 'fitment-table-title vehicle-specific',
        'key': '65'
    }, '\n    ', _translate(`fitment_table_vehicle_specific`), '\n  ') : null, this.noFitmentData ? _createElement('div', {
        'className': 'fitment-table-title no-fitment-data',
        'key': '208'
    }, '\n    ', window.Convermax.config?.fitmentUnknownTitle || _translate(`fitment_unknown_title`), _createElement('br', {}), window.Convermax.config?.fitmentUnknownText || _translate(`fitment_unknown_text`), '\n  ') : null, this.universalFit ? _createElement('div', {
        'className': 'fitment-table-title universal-fit',
        'key': '476'
    }, '\n    ', window.Convermax.config?.verifyFitmentUniversalTitle || window.Convermax.config?.fitmentUniversalTitle || _translate(`fitment_universal_title`), _createElement('br', {}), window.Convermax.config?.verifyFitmentUniversalText || window.Convermax.config?.fitmentUniversalText || _translate(`fitment_universal_text`), '\n  ') : null, this.manyFitments ? _createElement('div', {
        'className': 'fitment-table-title many-fitments',
        'key': '860'
    }, '\n    ', _translate(`fitment_table_many_fitments`), '\n  ') : null, this.template === 'horizontal' ? _createElement('div', {
        'className': 'cm_fitment-table__horizontal cmTemplate_horizontal',
        'key': '995'
    }, _createElement('div', { 'className': 'cm_fitment-table__scroll' }, _createElement('div', { 'className': 'cm_fitment-table__table-wrap' }, _createElement('table', { 'className': 'fitment-table fitment-table-horizontal' }, [_createElement('thead', {
            'className': 'fitment-table-header',
            'key': '12740'
        }, _createElement.apply(this, [
            'tr',
            { 'className': 'fitment-row' },
            _map(this.fields, repeatField2.bind(this))
        ]))], _createElement.apply(this, [
        'tbody',
        { 'className': 'fitment-table-body fitment-table-fitment cmRepeater_alwaysVisibleValues' },
        _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues3.bind(this))
    ]), _createElement.apply(this, [
        'tbody',
        { 'className': 'fitment-table-body fitment-table-fitment cm_collapsible-elem cmRepeater_initiallyHiddenValues' },
        _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues4.bind(this))
    ])), this.vehicleSpecific ? _createElement('div', {
        'className': 'fitment-table-notice',
        'key': '7981'
    }, _createElement('span', { 'className': 'fitment-table-notice__icon' }, '!'), _createElement('span', {}, 'Always read all product page details for more important fitment information.')) : null))) : null, this.template === 'vertical' ? _createElement('div', {
        'className': 'cm_fitment-table__horizontal cmTemplate_vertical',
        'key': '8255'
    }, _createElement('div', { 'className': 'cm_fitment-table__scroll' }, _createElement('div', { 'className': 'cm_fitment-table__table-wrap' }, _createElement('table', { 'className': 'fitment-table fitment-table-horizontal' }, [_createElement('thead', {
            'className': 'fitment-table-header',
            'key': '85300'
        }, _createElement.apply(this, [
            'tr',
            { 'className': 'fitment-row' },
            _map(this.fields, repeatField5.bind(this))
        ]))], _createElement.apply(this, [
        'tbody',
        { 'className': 'fitment-table-body fitment-table-fitment cmRepeater_alwaysVisibleValues' },
        _map(this.alwaysVisibleValues, repeatAlwaysVisibleValues6.bind(this))
    ]), _createElement.apply(this, [
        'tbody',
        { 'className': 'fitment-table-body fitment-table-fitment cm_collapsible-elem cmRepeater_initiallyHiddenValues' },
        _map(this.initiallyHiddenValues, repeatInitiallyHiddenValues7.bind(this))
    ])), this.vehicleSpecific ? _createElement('div', {
        'className': 'fitment-table-notice',
        'key': '15237'
    }, _createElement('span', { 'className': 'fitment-table-notice__icon' }, '!'), _createElement('span', {}, 'Always read all product page details for more important fitment information.')) : null))) : null, this.initiallyHiddenValues?.length ? _createElement('div', {
        'className': 'cm_fitment-table_collapse-button-container',
        'key': '15512'
    }, _createElement('button', {
        'className': 'cm_fitment-table_collapse-button button',
        'onClick': this.toggleCollapsed
    }, this.isCollapsed ? [_translate(`show_more`, {  valuesCount : this. valuesCount  })] : null, !this.isCollapsed ? [_translate(`show_less`)] : null)) : null);
}
        export const componentNames = []